/** Splits a string in PascalCase into words (e.g. VersionNumber to 'Version Number') */
export function splitPascalCase(value: string): string {
  return value.replace(/([a-z])([A-Z])/g, '$1 $2'); // Split casing difference with space (e.g. lower Upper)
}
